import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseSection } from '../components/WhyChooseSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { CTASection } from '../components/CTASection';

export const HomePage = () => {
  return (
    <>
      <Helmet>
        <title>Heritage Home Health LLC | Compassionate In-Home Care Services</title>
        <meta
          name="description"
          content="Heritage Home Health LLC provides personalized, compassionate in-home care services including personal care, companionship, daily living support, and respite care. Trusted by families for 15+ years."
        />
        <meta
          name="keywords"
          content="home health care, in-home care, compassionate care, senior care, personalized home care, Heritage Home Health LLC, elderly care, caregiver services"
        />
      </Helmet>
      <div className="min-h-screen bg-warm-beige" data-testid="home-page">
        <Navigation />
        <main>
          <HeroSection />
          <ServicesSection />
          <WhyChooseSection />
          <TestimonialsSection />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;
